/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Reformulation_HintInputs */

const en_keyword_optimizer_reformulation_hint = /** @type {(inputs: Keyword_Optimizer_Reformulation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review each suggestion and accept or reject it.`)
};

const de_keyword_optimizer_reformulation_hint = /** @type {(inputs: Keyword_Optimizer_Reformulation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfe jeden Vorschlag und akzeptiere oder lehne ihn ab.`)
};

const fr_keyword_optimizer_reformulation_hint = /** @type {(inputs: Keyword_Optimizer_Reformulation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examinez chaque suggestion et acceptez-la ou rejetez-la.`)
};

const es_keyword_optimizer_reformulation_hint = /** @type {(inputs: Keyword_Optimizer_Reformulation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa cada sugerencia y acéptala o recházala.`)
};

const it_keyword_optimizer_reformulation_hint = /** @type {(inputs: Keyword_Optimizer_Reformulation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esamina ogni suggerimento e accettalo o rifiutalo.`)
};

const nl_keyword_optimizer_reformulation_hint = /** @type {(inputs: Keyword_Optimizer_Reformulation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk elke suggestie en accepteer of wijs deze af.`)
};

const pl_keyword_optimizer_reformulation_hint = /** @type {(inputs: Keyword_Optimizer_Reformulation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejrzyj każdą sugestię i zaakceptuj ją lub odrzuć.`)
};

const fi_keyword_optimizer_reformulation_hint = /** @type {(inputs: Keyword_Optimizer_Reformulation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkista jokainen ehdotus ja hyväksy tai hylkää se.`)
};

const da_keyword_optimizer_reformulation_hint = /** @type {(inputs: Keyword_Optimizer_Reformulation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemgå hvert forslag og acceptér eller afvis det.`)
};

const sv_keyword_optimizer_reformulation_hint = /** @type {(inputs: Keyword_Optimizer_Reformulation_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Granska varje förslag och godkänn eller avvisa det.`)
};

/**
* | output |
* | --- |
* | "Review each suggestion and accept or reject it." |
*
* @param {Keyword_Optimizer_Reformulation_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_reformulation_hint = /** @type {((inputs?: Keyword_Optimizer_Reformulation_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Reformulation_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_reformulation_hint(inputs)
	if (locale === "fr") return fr_keyword_optimizer_reformulation_hint(inputs)
	if (locale === "es") return es_keyword_optimizer_reformulation_hint(inputs)
	if (locale === "it") return it_keyword_optimizer_reformulation_hint(inputs)
	if (locale === "nl") return nl_keyword_optimizer_reformulation_hint(inputs)
	if (locale === "pl") return pl_keyword_optimizer_reformulation_hint(inputs)
	if (locale === "fi") return fi_keyword_optimizer_reformulation_hint(inputs)
	if (locale === "da") return da_keyword_optimizer_reformulation_hint(inputs)
	if (locale === "sv") return sv_keyword_optimizer_reformulation_hint(inputs)
	return en_keyword_optimizer_reformulation_hint(inputs)
});